define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/notificationTab/notificationView.tmpl"),
        Button = require("ui/button/Button"),
        DropdownMenu = require("ui/dropdown-menu/DropdownMenu"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        NotificationView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        NotificationView = Marionette.ItemView.extend({
            template: template,
            className: 'notification-view',
            ui: {
                title: ".notification-Title",
                description: ".notification-description",
                details: ".notification-details",
                notificationRemove: ".delete-button",
                cancelButton: ".cancel-button"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events:{
                        "click":"_onCancel"
                    }
                },
                deleteButton: {
                    type: Button,
                    options: {
                        el: "view.ui.notificationRemove",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events:{
                      "click":"_onDelete"
                    }
                }
            },

            initialize: function (options) {
                this.model = options.model;
                this.channel = options.channel;
            },

            onRender: function () {
                // we need to do this, bc if we directly add the details via template, the html tags wont work :(
                this.ui.details.html(this.model.get('details'));
            },
            _onCancel: function () {
                this.channel.vent.trigger("NotificationViewController::window:close");
            },

            _onDelete: function () {
                this.channel.vent.trigger("NotificationViewController::notification:remove", this.model);
            }

        });
    });
    return NotificationView;
});
